// extracted by mini-css-extract-plugin
module.exports = {"download":"download_download__Jwmkx"};